<template>
  <div>
    <el-tabs class="el-tabs__customize">
      <el-tab-pane label="分包商信息">
        <el-form :model="form" label-width="180px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="分包商名称：">
                <span>{{ form.supName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  `${
                    purchaseType == 1 ||
                    purchaseType == 2 ||
                    purchaseType == 4 ||
                    purchaseType == 7 ||
                    purchaseType == 8
                      ? '响应'
                      : '投标'
                  }总金额(${form.moneyUnitName}) ：`
                "
              >
                <!-- <span>{{
                  form.priceAmount
                    ? new BigNumber(form.priceAmount).toFormat(2)
                    : ""
                }}</span> -->
                <span>{{ new BigNumber(form.priceAmount).toFormat(8) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报价时间：">
                <span>{{ form.priceTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人：">
                <span>{{ form.contractName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码：">
                <span>{{ form.mobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮件地址：">
                <span>{{ form.email }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-tabs class="el-tabs__customize">
      <el-tab-pane label="报价清单">
        <iframe
          class="no-print"
          id="reportFrame"
          style="width: 100%;"
          :src="pageUrl"
          frameborder="0"
        ></iframe>
        <!-- <el-tabs
          class="el-tabs__customize"
          :active-name="activeName"
          v-if="!packId && subPackageFlag === '1'"
        >
          <template
            v-for="(itemBox, indexBox) in form.packOpenEngineerQuoteBOList"
          >
            <el-tab-pane
              v-if="getTaxAmountIsShow(itemBox.engineerQuoteBOList)"
              :key="indexBox"
              :label="itemBox.packName"
              :name="indexBox + ''"
            >
              <template>
                
                <el-table
                  :data="itemBox.engineerQuoteBOList"
                  border
                  :span-method="spanMethod"
                >
                  <el-table-column label="序号" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index }}</span>
                    </template>
                  </el-table-column>
                  <template v-for="(item, index) in columns">
                    <el-table-column
                      v-if="item.type"
                      :key="index"
                      :type="item.type"
                      :label="item.label"
                    ></el-table-column>
                    <el-table-column
                      v-else
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                    >
                      <template
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          v-bind="child"
                        >
                          <template slot-scope="{ row }">
                            <span
                              v-if="
                                child.showPoint && row[child.prop] && row.isLast
                              "
                              >{{
                                (row[child.prop] || "").toString()
                                  | NumFormat(8)
                              }}</span
                            >
                           
                            <span v-else-if="row.isLast != 0">{{
                              new BigNumber(row[child.prop]).toFormat(8) ==
                              "NaN"
                                ? ""
                                : new BigNumber(row[child.prop]).toFormat(8)
                            }}</span>
                          </template>
                        </el-table-column>
                      </template>
                      <template slot-scope="{ row }">
                        <span v-if="item.showPoint && row[item.prop]">{{
                          (row[item.prop] || "").toString()
                            | NumFormat(item.showPoint)
                        }}</span>
                        <span v-else>{{ row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
              </template>
            </el-tab-pane>
          </template>
        </el-tabs>
        <template v-else>
          <el-table
            :data="form.packOpenEngineerQuoteBOList[0].engineerQuoteBOList"
            border
            :span-method="spanMethod"
          >
            <el-table-column label="序号" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index }}</span>
              </template>
            </el-table-column>
            <template v-for="(item, index) in columns">
              <el-table-column
                v-if="item.type"
                :key="index"
                :type="item.type"
                :label="item.label"
              ></el-table-column>
              <el-table-column
                v-else
                :key="index"
                :show-overflow-tooltip="true"
                v-bind="item"
              >
                <template v-if="item.labelChild && item.labelChild.length > 0">
                  <el-table-column
                    v-for="(child, indexch) in item.labelChild"
                    :key="indexch"
                    v-bind="child"
                  >
                    <template slot-scope="{ row }">
                      <span
                        v-if="child.showPoint && row[child.prop] && row.isLast"
                        >{{
                          (row[child.prop] || "").toString() | NumFormat(8)
                        }}</span
                      >
                    
                      <span v-else-if="row.isLast != 0">{{
                        new BigNumber(row[child.prop]).toFormat(8) == "NaN"
                          ? ""
                          : new BigNumber(row[child.prop]).toFormat(8)
                      }}</span>
                    </template>
                  </el-table-column>
                </template>
                <template slot-scope="{ row }">
                  <span v-if="item.showPoint && row[item.prop]"
                    >{{
                      (row[item.prop] || "").toString()
                        | NumFormat(item.showPoint)
                    }}
                    {{ item.unitProp && row[item.unitProp] }}
                  </span>
                  <span v-else>{{ row[item.prop] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </template> -->
      </el-tab-pane>
      <el-tab-pane
        :label="
          `${
            purchaseType == 1 ||
            purchaseType == 2 ||
            purchaseType == 4 ||
            purchaseType == 7 ||
            purchaseType == 8
              ? '响应'
              : '投标'
          }文件`
        "
      >
        <el-tabs
          class="el-tabs__customize"
          :active-name="fileActiveName"
          v-if="!packId && subPackageFlag === '1'"
          @tab-click="fileTabClick"
        >
          <template v-for="(item, index) in form.packOpenEngineerQuoteBOList">
            <el-tab-pane :key="index" :label="item.packName" :name="index + ''">
            </el-tab-pane>
          </template>
        </el-tabs>
        <el-table :data="fileTableData" border>
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            property="fileName"
            label="附件名称"
            show-overflow-tooltip
            min-width="100"
          ></el-table-column>
          <el-table-column
            property="fileSize"
            label="附件大小"
            show-overflow-tooltip
            min-width="120"
          >
            <template slot-scope="{ row }">
              <span>{{ row.fileSize }}K</span>
            </template>
          </el-table-column>
          <el-table-column
            property="fileSumm"
            label="附件说明"
            show-overflow-tooltip
            min-width="120"
          ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="{ row }">
              <el-button type="text" @click="download(row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="项目负责人">
        <userList
          :noDisabled="false"
          :extTable="form.packOpenEngineerQuoteBOList[0].projectPersons || []"
          ref="projectPersons"
        ></userList>
      </el-tab-pane>
      <el-tab-pane label="技术负责人">
        <userList
          :noDisabled="false"
          :extTable="form.packOpenEngineerQuoteBOList[0].techPersons || []"
          ref="techPersons"
        ></userList>
      </el-tab-pane>
      <el-tab-pane label="安全负责人">
        <userList
          :noDisabled="false"
          :extTable="form.packOpenEngineerQuoteBOList[0].securityPersons || []"
          ref="securityPersons"
        ></userList>
      </el-tab-pane>
      <el-tab-pane label="其他人员">
        <userList
          :noDisabled="false"
          :extTable="form.packOpenEngineerQuoteBOList[0].otherPersons || []"
          ref="otherPersons"
        ></userList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  scpQryFileinfoListApi,
  scpQrySupBidOpenDetail
  // scpQrySupQuoteDetail
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import userList from "./userList.vue";
import { addUrlPerFix } from "@/basa/utils";
// import { NumFormat } from "@/basa/filters";
import BigNumber from "bignumber.js";
export default {
  name: "subSupplierBidDetails",
  props: {
    supQuoteId: {
      type: String,
      default: ""
    },
    supPackQuoteId: {
      type: String,
      default: ""
    },
    supCode: {
      type: String,
      default: ""
    },
    packId: {
      type: String,
      default: ""
    }
  },
  components: {
    userList
  },
  data() {
    return {
      pageUrl: "",
      encodedFilePath: "scma-report%252F分包商报价清单.cpt",
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType,
      BigNumber: BigNumber,
      form: {
        packOpenEngineerQuoteBOList: [
          {
            engineerQuoteBOList: []
          }
        ]
      },
      quoteTableData: [],
      fileTableData: [],
      columns: [
        {
          prop: "engerCode",
          label: "编码",
          width: 300
        },
        {
          prop: "engerName",
          label: "名称",
          width: 300
        },

        {
          prop: "quantities",
          label: "工程量",
          width: 120,
          showPoint: 3,
          unitProp: "unitName" //工程量后面要显示计量单位
        },
        {
          prop: "free4",
          label: "投标限价",
          width: 120,
          showPoint: 2,
          free4Name: "free4"
        },

        {
          prop: "price",
          label: "单价",
          labelChild: [
            {
              prop: "taxConvPriceAmount",
              label: "含税单价",
              width: 180,
              align: "right",
              showPoint: 8
            },
            {
              prop: "convPriceAmount",
              label: "不含税单价",
              width: 180,
              align: "right",
              showPoint: 8
            }
          ]
        },
        {
          prop: "taxName",
          label: "税率（%）",
          width: 120
        },
        {
          prop: "allprice", /////////////////
          label: "合价",
          labelChild: [
            {
              prop: "taxPriceAmount",
              label: "含税金额",
              width: 180,
              align: "right",
              showPoint: 8
            },
            {
              prop: "priceAmount",
              label: "不含税金额",
              width: 180,
              align: "right",
              showPoint: 8
            },
            {
              prop: "taxAmount",
              label: "税额",
              width: 180,
              align: "right",
              showPoint: 8
            }
          ]
        },
        {
          prop: "featRemark",
          label: "项目特征描述",
          width: 120
        },
        {
          prop: "remark",
          label: "报价要求",
          width: 120
        }
      ],
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      activeName: "0",
      fileActiveName: "0",
      subPackageFlag: false
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    getTaxAmountIsShow(data) {
      // console.log("data", data);
      if (data.length < 2) return false;
      else return true;
      // return true;
    },
    fileTabClick({ name }) {
      this.getFileData(this.form.packOpenEngineerQuoteBOList[name].packId);
    },
    getFileData(packId, supQuoteId) {
      let obj = {
        parentBillId: supQuoteId || this.form.supQuoteId || this.supQuoteId,
        billType: "0603",
        uploadPhase: "0603"
      };
      if (this.subPackageFlag == "1") {
        obj.billId = packId;
      }
      scpQryFileinfoListApi(obj).then(res => {
        this.fileTableData = res.data.data;
      });
    },
    getData() {
      // if (this.packId !== "") {
      this.pageUrl = `${this.$addUrlPerFix(
        process.env.VUE_APP_FINEREPORT_SERVLET_URL
      )}?viewlet=${this.encodedFilePath}&schemeId=${this.schemeId}&packId=${
        this.packId ? this.packId : ""
      }&supCode=${this.supCode}&supPackQuoteId=${this.supPackQuoteId}`;
      console.log(this.pageUrl, "this.pageUrl.....");

      let params = {
        schemeId: this.schemeId,
        supCode: this.supCode,
        supPackQuoteId: this.supPackQuoteId,
        purStep: 6
      };
      if (this.packId && this.packId !== "0") {
        params.packId = this.packId;
      }
      scpQrySupBidOpenDetail(params).then(res => {
        if (res.data.code === "0") {
          res.data.data.packOpenEngineerQuoteBOList.forEach((item, index) => {
            let priceAmountAll = 0;
            let taxPriceAmountAll = 0;
            let taxAmountAll = 0;
            item.engineerQuoteBOList.forEach((itemTwo, index) => {
              itemTwo.id = index + 1;
              priceAmountAll += itemTwo.priceAmount - 0;
              taxPriceAmountAll += itemTwo.taxPriceAmount;
              taxAmountAll += itemTwo.taxAmount;
              if (itemTwo.free4) {
                itemTwo.free4 = new BigNumber(itemTwo.free4).toFormat(2);
              }
            });
            item.engineerQuoteBOList.unshift({
              engerCode: "报价小计：",
              taxAmount: taxAmountAll,
              taxPriceAmount: taxPriceAmountAll,
              priceAmount: priceAmountAll
            });
          });
          this.form = res.data.data;
          this.columns[4].label = "单价（" + res.data.data.moneyUnitName + ")";
          this.columns[6].label = "合价（" + res.data.data.moneyUnitName + ")";
          this.fileTableData = res.data.data.sscPurchaseFileBOS;
        }
      });
      // }
      //  else {
      // scpQrySupQuoteDetail({
      //   schemeId: this.schemeId,
      //   supCode: this.supCode,
      //   purStep: 6
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     res.data.data.packOpenEngineerQuoteBOList.forEach((item, index) => {
      //       item.packStatus !== "1" && (item.packName += "（已流标）");
      //       let priceAmountAll = 0;
      //       let taxPriceAmountAll = 0;
      //       let taxAmountAll = 0;
      //       item.engineerQuoteBOList.forEach((itemTwo, index) => {
      //         itemTwo.id = index + 1;
      //         priceAmountAll += itemTwo.priceAmount - 0;
      //         taxPriceAmountAll += itemTwo.taxPriceAmount;
      //         taxAmountAll += itemTwo.taxAmount;
      //         if (itemTwo.free4) {
      //           itemTwo.free4 = new BigNumber(itemTwo.free4).toFormat(2);
      //         }
      //       });
      //       item.engineerQuoteBOList.unshift({
      //         engerCode: "报价小计：",
      //         taxAmount: taxAmountAll,
      //         taxPriceAmount: taxPriceAmountAll,
      //         priceAmount: priceAmountAll
      //       });
      //     });
      //     this.form = res.data.data;
      //     this.subPackageFlag = res.data.data.subPackageFlag;
      //     this.columns[4].label =
      //       "单价（" + res.data.data.moneyUnitName + ")";
      //     this.columns[6].label =
      //       "合价（" + res.data.data.moneyUnitName + ")";
      //     this.getFileData(
      //       res.data.data.packOpenEngineerQuoteBOList[0].packId,
      //       res.data.data.supQuoteId
      //     );
      //   }
      // });
      // }
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex < 4 && columnIndex !== 1) {
          return [0, 0];
        } else if (columnIndex >= 4) {
          return [1, 1];
        } else {
          return [1, 4];
        }
      }
      return [1, 1];
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid-scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-form .el-form-item {
  margin-bottom: 20px !important;
}
/deep/ .el-tabs__customize {
  .el-tabs__header {
    margin-bottom: 20px !important;
    padding-top: 20px !important;
  }
}
</style>
